import React from "react";
import { useSelector } from "react-redux";
import Breadcrumbs from "./Breadcrumbs";
import NavBar from "./NavBar";
import { useMobileMenu } from "../context/MobileMenuContext";

export default function HomeLayout({ children }) {
  const { isOpen, close } = useMobileMenu();

  return (
    <div className="flex h-[calc(100vh-73px)]">
      <NavBar />

      {/* Main content */}
      <div className="flex-1 overflow-auto">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-2">
          <Breadcrumbs />
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}
